import { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { isEmpty } from 'lodash';
import { clearCmsData, getCms } from '../../../store/home/actions';
import { clearEventData, getEvents } from '../../../store/events/actions';
import { readableCityName } from '../../../common/commonFunction';

const useOnlineEvents = (router) => {
    const dispatch = useDispatch();
    const swiperRef = useRef(null);

    const { events, totalEvents } = useSelector((state) => ({
        events: state.events.events,
        totalEvents: state.events.totalEvents,
    }));

    let filterData = {
        start: 0,
        limit: 15,
        search: '',
        sort_by: '',
        sort_order: 'desc',
        status: '',
        category_id: '',
        distribution_type: 'Online',
    };

    const getListData = useCallback(
        (status, search, start, loadMoreData) => {
            filterData.status = status || '';
            filterData.search = search || filterData.search;
            filterData.start = start || 0;

            dispatch(getEvents(filterData, router.navigate));
        },
        [dispatch, router.navigate],
    );

    useEffect(() => {
        dispatch(clearEventData());
        getListData('', '', '', false);
    }, []);

    const loadMore = () => {
        const start = filterData.start + filterData.limit;
        filterData.start = start;
        getListData(filterData.status, filterData.search, start, true);
    };

    const handlePageClick = () => {
        if (swiperRef.current) {
            swiperRef.current.autoplay.stop();
        }
    };

    const seoData = {
        seo_title: 'Discover Top Event Artists & Performers | Artist Directory – MePass',
        seo_description: 'Explore our complete list of artists and performers on MePass. View bios, event history, and profiles of musicians, comedians, speakers, and creators – all in one place.',
        seo_image: '',
        keywords: 'Artist Directory, Artist profiles, Event Artists, Event Performers, Artist Bio, profiles of musicians, Comedian profile'
    }
    return {
        events,
        totalEvents,
        swiperRef,
        loadMore,
        handlePageClick,
        seoData,
    };
};

export default useOnlineEvents;
